import { Section, SectionTitle, Reveal } from "@/components/Section";
import { useContent } from "@/i18n";
import { Shape3D, HandNote } from "@/components/Objects3D";

export const Gallery = () => {
  const { c, ui } = useContent();
  return (
    <Section id="gallery" num="09" chapter={ui.gallery.chapter} className="bg-ivory">
      <Shape3D shape="cloud" blue size={66} className="absolute right-[8%] top-20 opacity-80 hidden md:block" />
      <div className="flex flex-wrap items-end justify-between gap-6">
        <SectionTitle className="max-w-2xl">
          {ui.gallery.titleA} <span className="italic text-cobalt">{ui.gallery.titleB}</span>
        </SectionTitle>
        <Reveal delay={0.15}>
          <HandNote className="rotate-2">{ui.gallery.note}</HandNote>
        </Reveal>
      </div>

      <div className="mt-14 columns-2 lg:columns-4 gap-6 [column-fill:_balance]">
        {c.gallery.map((photo, i) => {
          const rotations = ["rotate-1", "-rotate-2", "rotate-2", "-rotate-1"];
          return (
            <Reveal key={photo.src + i} delay={0.04 * (i % 4)} className="mb-6 break-inside-avoid">
              <figure className={`tilt-hover group bg-white border border-line rounded-xl p-3 shadow-[0_16px_36px_-24px_rgba(51,38,25,0.3)] ${rotations[i % rotations.length]}`} data-testid={`gallery-item-${i}`}>
                <div className={`overflow-hidden rounded-lg bg-beige ${photo.ratio}`}>
                  <img
                    src={photo.src}
                    alt={photo.caption}
                    loading="lazy"
                    className="frame-zoom w-full h-full object-cover"
                  />
                </div>
                <figcaption className="px-2 py-3 flex items-baseline justify-between gap-3">
                  <span className="font-serif italic text-sm md:text-base text-choco/85">{photo.caption}</span>
                  <span className="shrink-0 text-[10px] tracking-[0.22em] uppercase text-cobalt font-bold">{photo.tag}</span>
                </figcaption>
              </figure>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
};
